import {
  isLspdDomainName,
  isProduction,
  isProductionDomain,
} from '@vend/utilities'
import {
  RECAPTCHA_DEV_SITE_KEY,
  RECAPTCHA_PUBLIC_SITE_KEY,
  RECAPTCHA_TEST_SITE_KEY,
  VEND_DOMAIN_SUFFIX,
} from '../constants/constants'

export const getVendDomainSuffix = (location: string): string => {
  const isDev = !isProductionDomain(location)
  if (isLspdDomainName(location)) {
    if (!isDev) {
      return VEND_DOMAIN_SUFFIX.lspdProd
    }
    const { hostname } = new URL(location)
    // Staging/sandbox envs carry a per-env label (e.g. secure.stg1.sandbox...),
    // so the suffix is everything after the first label, not a fixed constant.
    if (hostname.includes(VEND_DOMAIN_SUFFIX.lspdStaging)) {
      return hostname.substring(hostname.indexOf('.'))
    }
    return VEND_DOMAIN_SUFFIX.lspdDev
  }
  return isDev ? VEND_DOMAIN_SUFFIX.vendDev : VEND_DOMAIN_SUFFIX.vendProd
}

// Extract the prefix on the environments domain, e.g. catsandhats.vendhq.com
export const getDomainPrefix = (domainSuffix: string): string => {
  return window.location.hostname.substring(
    0,
    window.location.hostname.indexOf(domainSuffix)
  )
}

export const getRecaptchaKey = (): string => {
  if (isProduction(window.location.href)) {
    return RECAPTCHA_PUBLIC_SITE_KEY
  }

  if ('Cypress' in window) {
    return RECAPTCHA_TEST_SITE_KEY
  }

  return RECAPTCHA_DEV_SITE_KEY
}
